import React from "react";
import { ActivityIndicator, StatusBar, StyleSheet, View } from "react-native";
import { colors } from "@constants/theme";

const AuthLoadingScreen = () => {
  return (
    <View style={styles.container}>
      <ActivityIndicator size="large" color={colors.primary} />
      <StatusBar barStyle="default" />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
});

export default AuthLoadingScreen;
